// import * as companyService from "../../../services/company"

import * as companyManagementService from "../../../services/company";
import * as customerManagementService from "../../../services/customer";
import * as settings from "../../../services/settings";

import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Divider,
  Form,
  Input,
  Row,
  Select,
  Spin,
  Tabs,
  Typography,
  notification,
} from "antd";
import { useCallback, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { usePermission, useUser } from "../../../hooks/usePermission";

import { ArrowLeftOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import AuthGroup from "../../../../configs/authgroup";
import ContentType from "../../../../configs/contentType";
import { default as permissions } from "../../../../configs/permission"; // นำเข้า permission จากไฟล์ mapping
import { CreateCustomerDetail } from "../../../Components/customer/customerDetail";
import { CreateCustomerFormula } from "../../../Components/customer/customerFormula";
import { CreateCustomerRoutes } from "../../../Components/customer/customerRoute";
import BtnHistory from "../../../Components/model/button/history";
import { resolveImageUrl } from "../../../utils/imageUrl";
import { validateCreateCustomer } from "../../../Components/validations/validateCreateCompany";
import { useAccessToken } from "../../../contexts/AccessTokenContext";

const { Title, Text } = Typography;
const isCustomerCode = /^[A-Za-z0-9]+$/;

export const CustomerCreatePage = () => {
  const { accessToken } = useAccessToken();
  const { companyId: userCompanyId, saleId: userSaleId } = useUser();
  const { hasPermission, isSuperuser, hasGroup } = usePermission();
  const [formCustomer] = Form.useForm();
  const [isCreate, setIsCreate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [dataCustomer, setDataCustomer] = useState([]);
  const [isDisable, setIsDisable] = useState(true);
  const { t } = useTranslation("customer", "buttons");
  const [fileList, setFileList] = useState([]);
  const location = useLocation();
  const data = location.state;
  const [searchData, setSearchData] = useState("");
  const navigation = useNavigate();
  const [api, contextHolder] = notification.useNotification();

  const [validateCreateCustomerRequired, setValidateCreateCustomerRequired] = useState({
    fieldCustomerCode: false,
    fieldCustomerName: false,
    fieldCustomerCompany: false,
    fieldCustomerSale: false,
  });

  // search company and sales
  const [company, setCompany] = useState([]);
  const [customerCompanyId, setCustomerCompanyId] = useState();
  const [customerSaleId, setCustomerSaleId] = useState();
  const [customerCompanyName, setCustomerCompanyName] = useState("");
  const [customerSaleName, setCustomerSaleName] = useState("");
  const [isValidateCustomerSaleId, setIsValidateCustomerSaleId] = useState(false);
  const [selectDefaultCompany, setSelectDefaultCompany] = useState("");
  const [selectCustomerCompany, setSelectCustomerCompany] = useState([]);
  const [selectCustomerSales, setSelectCustomerSales] = useState([]);
  /** Bump when customer routes are created/updated/deleted so Formula tab refetches (backend auto-creates formulas per route). */
  const [customerRoutesVersion, setCustomerRoutesVersion] = useState(0);
  const notifyCustomerRoutesMutated = useCallback(() => {
    setCustomerRoutesVersion((v) => v + 1);
  }, []);

  const openNotificationWithIcon = (type, message, description) => {
    api[type]({
      message: message,
      description: description,
    });
  };

  const setDetailData = async (data) => {
    formCustomer.setFieldValue("customer_code", data.customer_code);
    formCustomer.setFieldValue("customer_name", data.customer_name);
    formCustomer.setFieldValue("customer_company", data.app_company.id);
    formCustomer.setFieldValue("customer_sale", data.app_sale.id);
    formCustomer.setFieldValue("customer_is_credit", data.is_credit);
    formCustomer.setFieldValue(
      "customer_line_id",
      data.app_customerline.length > 0 ? data.app_customerline[0].user_id : ""
    );
    formCustomer.setFieldValue("customer_tax_id", data.tax_id);
    formCustomer.setFieldValue("customer_email", data.email);
    formCustomer.setFieldValue("customer_telephone", data.telephone);
    formCustomer.setFieldValue("customer_address", data.customer_address);
    formCustomer.setFieldValue("delivery_address", data.delivery_address);
    formCustomer.setFieldValue("customer_note", data.note);

    if (data.app_company.id != undefined) {
      setIsValidateCustomerSaleId(true);
      await filterCompanySale(data.app_company.id);
    }

    if (data.app_customerimage.length > 0) {
      if (data.app_customerimage.length > 0) {
        let listImages = [];
        data.app_customerimage.map((value) => {
          let subUidImage = value.image.substring(35, 71);
          let newImages = {
            uid: value.id,
            name: `image_${value.id}.png`,
            status: "done",
            url: resolveImageUrl(value.image),
            id: value.id,
          };
          listImages.push(newImages);
        });
        setFileList(listImages);
      }
    }
  };

  const fetchCustomerCompany = useCallback(async () => {
    formCustomer.setFieldValue();
    setLoading(true);
    try {
      let companyList;
      if (isSuperuser) {
        companyList = await companyManagementService.getCompanysList(accessToken);
        companyList.map((value) => {
          company.push({
            id: value.id,
            company_name: value.company_name,
            company_code: value.company_code,
            sale: value.app_sale || [],
          });
        });
      } else {
        companyList = await companyManagementService.getCompanyById(accessToken, userCompanyId);
        company.push({
          id: companyList.id,
          company_name: companyList.company_name,
          company_code: companyList.company_code,
          sale: companyList.app_sale || [],
        });
      }
      await filterCompanySale(data.type === "EDIT" ? data.customerData.app_company.id : userCompanyId);
      setCompany(company);
    } catch (err) {
      console.error("[CustomerCreatePage] fetchCustomerCompany: ", err);
      const { message } = settings.getErrorMessage(err);
      openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
    } finally {
      setLoading(false);
    }
  }, [accessToken, isSuperuser, userCompanyId, data]);

  const handlerOnChangeCompany = useCallback(async (companyId) => {
    formCustomer.setFieldValue("customer_sale", null);
    setIsValidateCustomerSaleId(false);
    await filterCompanySale(companyId);
  }, []);

  const filterCompanySale = async (companyId) => {
    setSelectCustomerSales([]);
    let resCompany = [];
    let resCompanySales = [];
    company.map((list, index) => {
      resCompany.push({
        key: `company-${index}-${list.id}`,
        value: list.id,
        label: `${list.company_name}(${list.company_code})`,
      });
      if (companyId !== undefined && companyId == list.id) {
        let sale = list.sale;
        if (Array.isArray(sale) && sale.length > 0) {
          sale.map((listSale, index) => {
            resCompanySales.push({
              key: `sale-${index}-${listSale.id}`,
              value: listSale.id,
              label: `${listSale.sale_name}(${list.company_code}-${listSale.sale_name})`,
            });
          });
          setIsValidateCustomerSaleId(true);
        }
      }
    });

    // ✅ เพิ่ม All Company
    if (isSuperuser) {
      resCompany.unshift({
        key: "company-all",
        value: "ALL",
        label: "All Company",
      });
    }

    const uniqueOptions = Array.from(new Map(resCompany.map((item) => [item.value, item])).values());
    setSelectCustomerCompany(uniqueOptions);
    // อย่าตั้ง default เป็น "ALL" ซ้ำ ถ้า user เปลี่ยนเอง
    if (isSuperuser && companyId === "ALL") {
      setSelectDefaultCompany("ALL");
      setCustomerCompanyId(undefined);
    }

    // Unique sales
    let valueSale = resCompanySales.filter(
      (oldValue, index) => index === resCompanySales.findIndex((data) => data.value === oldValue.value)
    );

    // ✅ เพิ่ม option 'All'
    valueSale.unshift({
      key: "sale-all",
      value: "ALL",
      label: "All Sale",
    });

    // ✅ ตั้งค่าค่าเริ่มต้นตาม saleId (ถ้ามี)
    if (data.type !== "EDIT") {
      const defaultSale = valueSale.find((sale) => sale.value === userSaleId);
      if (defaultSale) {
        setCustomerSaleId(defaultSale.value);
        setCustomerSaleName(defaultSale.label);
      } else if (valueSale.length > 0) {
        setCustomerSaleId(valueSale[0].value);
        setCustomerSaleName(valueSale[0].label);
      }
    }

    // ถ้า user อยู่ใน group CompanySale
    if (!hasGroup(AuthGroup.CompanyOwner) && !isSuperuser) {
      if (userSaleId) {
        valueSale = valueSale.filter((sale) => sale.value === userSaleId);
      }
    }

    setSelectCustomerSales(valueSale);

    if (companyId !== undefined) {
      setCustomerCompanyId(companyId);
      setCustomerCompanyName(company.find((list) => list.id == companyId)?.company_name || "");
    }
  };

  const onSubmit = async () => {
    await formCustomer.validateFields();
    const values = await formCustomer.getFieldsValue();
    const {
      customer_code,
      customer_name,
      customer_company,
      customer_sale,
      customer_is_credit,
      customer_line_id,
      customer_tax_id,
      customer_email,
      customer_telephone,
      customer_address,
      delivery_address,
      customer_note,
    } = values || {};
    const { isValid } = validateCreateCustomer(values, isValidateCustomerSaleId);
    if (isValid) {
      const fromData = new FormData();
      // New Data
      fromData.append("customer_code", customer_code);
      fromData.append("customer_name", customer_name);
      fromData.append("company_id", customer_company);
      fromData.append("sale_id", customer_sale);
      fromData.append("is_credit_data", customer_is_credit || false);
      fromData.append("tax_id", customer_tax_id || "");
      fromData.append("email", customer_email || "");
      fromData.append("telephone", customer_telephone || "");
      fromData.append("customer_address", customer_address || "");
      fromData.append("delivery_address", delivery_address || "");
      fromData.append("note", customer_note || "");
      fromData.append("customer_line", customer_line_id || "");
      fromData.append("customer_company_name", customerCompanyName || "");
      fromData.append("customer_sale_name", customerSaleName || "");

      // Old Data
      if (data.type !== "CREATE") {
        fromData.append("old_customer_code", data.customerData.customer_code || "");
        fromData.append("old_customer_name", data.customerData.customer_name || "");
        fromData.append("old_company_id", data.customerData.app_company.id || "");
        fromData.append("old_sale_id", data.customerData.app_sale.id || "");
        fromData.append("old_is_credit_data", data.customerData.is_credit || false);
        fromData.append("old_tax_id", data.customerData.tax_id || "");
        fromData.append("old_email", data.customerData.email || "");
        fromData.append("old_telephone", data.customerData.telephone || "");
        fromData.append("old_customer_address", data.customerData.customer_address || "");
        fromData.append("old_delivery_address", data.customerData.delivery_address || "");
        fromData.append("old_note", data.customerData.note || "");
        fromData.append("old_customer_line", data.customerData.app_customerline[0]?.user_id || "");
      }
      const old_images = [];
      if (fileList.length > 0) {
        fileList.map((file) => {
          if (file.id) {
            old_images.push(file.id);
          } else {
            fromData.append("file", file.originFileObj);
          }
        });
        fromData.append("old_images", JSON.stringify(old_images));
      }
      setLoading(true);
      try {
        if (data.type === "CREATE") {
          const response = await customerManagementService.createCustomer(accessToken, fromData);
          if (response !== null || response != undefined) {
            openNotificationWithIcon(
              settings.NotificationType.SUCCESS,
              <>{"Success."}</>,
              <>{"Create customer success"}</>
            );
            const dataCustomer = await customerManagementService.getCustomerById(accessToken, response.id);
            setLoading(false);
            setIsDisable(false);
            setDetailData(dataCustomer);
            setIsCreate(true);
            setDataCustomer(dataCustomer);
            setTimeout(() => {
              navigation("/customer");
            }, 2000);
          }
        } else {
          if (typeof customer_company === "string") {
            fromData.append("company_id", data.customerData.app_company.id);
          }
          if (typeof customer_sale === "string") {
            fromData.append("sale_id", data.customerData.app_sale.id);
          }
          const response = await customerManagementService.updateCustomer(accessToken, data.customerData.id, fromData);
          if (response !== null || response != undefined) {
            openNotificationWithIcon(
              settings.NotificationType.SUCCESS,
              <>{"Success."}</>,
              <>{"update customer success"}</>
            );
            setDetailData(response);
            setLoading(false);
          }
        }
      } catch (err) {
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
        console.error("[CustomerCreatePage] onSubmit: ", err);
        setLoading(false);
      }
    } else {
      openNotificationWithIcon(
        settings.NotificationType.ERROR,
        <>{"ERROR."}</>,
        <>{`Please check data is request create/update customer`}</>
      );
      setLoading(false);
    }
  };

  const isValidateCreateCustomerCode = (_, value) => {
    if (value !== "" && !isCustomerCode.test(value)) {
      setValidateCreateCustomerRequired({
        ...validateCreateCustomerRequired,
        fieldCustomerCode: false,
      });
      return Promise.reject("Please check from input");
    }

    setValidateCreateCustomerRequired({
      ...validateCreateCustomerRequired,
      fieldCustomerCode: true,
    });

    return Promise.resolve();
  };

  const isValidateCreateCustomerName = (_, value) => {
    if (value == "") {
      setValidateCreateCustomerRequired({
        ...validateCreateCustomerRequired,
        fieldCustomerName: false,
      });

      return Promise.reject("Please check from input");
    }

    setValidateCreateCustomerRequired({
      ...validateCreateCustomerRequired,
      fieldCustomerName: true,
    });

    return Promise.resolve();
  };

  const isValidateCreateCustomerCompany = (_, value) => {
    if (value == "") {
      setValidateCreateCustomerRequired({
        ...validateCreateCustomerRequired,
        fieldCustomerCompany: false,
      });

      return Promise.reject("Please check from select");
    }

    setValidateCreateCustomerRequired({
      ...validateCreateCustomerRequired,
      fieldCustomerCompany: true,
    });

    return Promise.resolve();
  };

  const isValidateCreateCustomerSale = (_, value) => {
    if (value == "") {
      setValidateCreateCustomerRequired({
        ...validateCreateCustomerRequired,
        fieldCustomerSale: false,
      });
    }
    setValidateCreateCustomerRequired({
      ...validateCreateCustomerRequired,
      fieldCustomerSale: true,
    });

    return Promise.resolve();
  };

  const handleChange = (value) => {
    setCustomerSaleId(value);
  };

  const fetchCustomerById = useCallback(
    async (param) => {
      setLoading(true);
      try {
        const dataCustomer = await customerManagementService.getCustomerById(accessToken, param.id);
        setDetailData(dataCustomer);
        setDataCustomer(dataCustomer);
      } catch (err) {
        console.error("[CustomerCreatePage] fetchCustomerById: ", err);
        const { message } = settings.getErrorMessage(err);
        openNotificationWithIcon(settings.NotificationType.ERROR, <>{"ERROR."}</>, <>{`${message}`}</>);
      }
      setLoading(false);
    },
    [accessToken]
  );

  useEffect(() => {
    setLoading(true);
    if (!accessToken) return;
    fetchCustomerCompany();

    if (data.type === "EDIT") {
      fetchCustomerById(data.customerData);
      setDetailData(data.customerData);
      setIsDisable(false);
    }

    if (isSuperuser) {
      setSelectDefaultCompany("ALL");
      formCustomer.setFieldsValue({ customer_company: "ALL" });
    } else if (userCompanyId) {
      setSelectDefaultCompany(userCompanyId);
      setCustomerCompanyId(userCompanyId);
      formCustomer.setFieldsValue({ customer_company: userCompanyId });
    }

    if (data.type === "CREATE" && userSaleId) {
      setCustomerSaleId(userSaleId);
      formCustomer.setFieldsValue({ customer_sale: userSaleId });
    } else {
      // Fix create images not sent sale_id
      setCustomerSaleId(userSaleId);
      formCustomer.setFieldsValue({ customer_sale: userSaleId });
    }
  }, [accessToken, data.customerData, formCustomer]);

  useEffect(() => {
    if (selectDefaultCompany) {
      formCustomer.setFieldsValue({ customer_company: selectDefaultCompany });
    }
    if (customerSaleId) {
      formCustomer.setFieldsValue({ customer_sale: customerSaleId });
    }
  }, [selectDefaultCompany, customerSaleId]);

  const initialItems = [
    {
      label: t("Customer_Create.Create_Detail.Title"),
      children: (
        <CreateCustomerDetail
          t={t}
          type={data.type}
          formCustomer={formCustomer}
          detailData={isCreate ? dataCustomer : data.customerData}
          setFileList={setFileList}
          fileList={fileList}
        />
      ),
      key: "1",
      visible: true,
    },
    {
      label: t("Customer_Create.Create_Route.Title"),
      children: (
        <CreateCustomerRoutes
          t={t}
          detailData={isCreate ? dataCustomer : data.customerData}
          onRoutesMutated={notifyCustomerRoutesMutated}
        />
      ),
      key: "2",
      disabled: isDisable,
      visible: hasPermission(permissions.CustomerRoute?.VIEW),
    },
    {
      label: t("Customer_Create.Create_Formula.Title"),
      children: (
        <CreateCustomerFormula
          t={t}
          detailData={isCreate ? dataCustomer : data.customerData}
          formulaRefreshKey={customerRoutesVersion}
        />
      ),
      key: "3",
      disabled: isDisable,
      visible: hasPermission(permissions.CustomerFormula?.VIEW),
    },
  ];

  const items = [
    {
      title: <span>{t("Page_Body_Tab_Menu.Home", { ns: "menus" })}</span>,
    },
    {
      title: <span>{t("Page_Body_Tab_Menu.Menu", { ns: "menus" })}</span>,
    },
    {
      title: <a href="/customer">{t("Title_Customer")}</a>,
    },
    {
      title: (
        <a href="/customer/create" style={{ fontWeight: 600, color: "black" }}>
          {data.type == "EDIT" ? t("Customer_Create.Title_Edit") : t("Customer_Create.Title_Create")}
        </a>
      ),
    },
  ];

  const handleSearch = async (value) => {
    if (!value) {
      setSearchData("");
    } else if (value !== searchData) {
      setSearchData("");
    }
    setSearchData(value);
    await filterCompanySale(value);
  };

  const filterOption = (input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  return (
    <>
      {contextHolder}
      <Spin spinning={loading}>
        <Row flex={1} style={{ overflowX: "auto" }}>
          <Col span={24}>
            <Breadcrumb items={items}></Breadcrumb>
            <Row className="mt-4" justify={"space-between"}>
              <Col span={12}>
                <Title
                  level={4}
                  style={{
                    textWrap: "nowrap",
                    display: "flex",
                    gap: "7px",
                  }}
                >
                  <a href="/customer">
                    <ArrowLeftOutlined style={{ fontSize: "20px" }} />
                  </a>
                  {data.type == "EDIT" ? t("Customer_Create.Title_Edit") : t("Customer_Create.Title_Create")}
                </Title>
              </Col>
              {data.type == "EDIT" && (
                <Col>
                  <BtnHistory
                    titleRef={dataCustomer?.customer_name}
                    customer_id={dataCustomer?.id}
                    content_type_id={[
                      ContentType.Customer,
                      ContentType.CustomerFormula,
                      ContentType.CustomerLine,
                      ContentType.CustomerRoute,
                      ContentType.CustomerImage,
                    ]}
                  />
                </Col>
              )}
            </Row>
          </Col>
          <Divider />
          {/* <!-- from --> */}
          <Col span={24} style={{ minWidth: 640 }}>
            <Form
              form={formCustomer}
              layout={{
                labelCol: {
                  span: 12,
                },
                wrapperCol: {
                  span: 12,
                },
              }}
            >
              <Row>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Customer_Create.Customer_Code") + ":"}
                    name="customer_code"
                    key="customer_code"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true, whitespace: true }, { validator: isValidateCreateCustomerCode }]}
                  >
                    <Input
                      allowClear={true}
                      size="default"
                      placeholder={"exmaples"}
                      maxLength={10}
                      style={{ minWidth: 200 }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Customer_Create.Customer_Name") + ":"}
                    name="customer_name"
                    key="customer_name"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: isValidateCreateCustomerName }]}
                  >
                    <Input allowClear={true} size="default" placeholder={"example"} style={{ minWidth: 200 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Customer_Create.Customer_Company") + ":"}
                    name="customer_company"
                    key="customer_company"
                    style={{ marginBottom: "1rem" }}
                    rules={[{ required: true }, { validator: isValidateCreateCustomerCompany }]}
                  >
                    <Select
                      value={selectDefaultCompany}
                      style={{ width: "100%", minWidth: 200 }}
                      showSearch
                      onSearch={handleSearch}
                      placeholder={"Please Select Company"}
                      options={selectCustomerCompany}
                      filterOption={filterOption}
                      onChange={(value) => {
                        setSelectDefaultCompany(value);
                        if (value === "ALL") {
                          setCustomerCompanyId(undefined); // ✅ ล้างค่า ถ้าเลือก All
                        } else {
                          setCustomerCompanyId(value);
                        }
                        handlerOnChangeCompany(value);
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={12} style={{ minWidth: 200 }}>
                  <Form.Item
                    label={t("Customer_Create.Customer_Sale") + ":"}
                    name="customer_sale"
                    key="customer_sale"
                    style={{ marginBottom: "1rem" }}
                    rules={[
                      { required: selectCustomerSales.length > 0 ? true : false },
                      { validator: selectCustomerSales.length > 0 ? isValidateCreateCustomerSale : false },
                    ]}
                  >
                    <Select
                      value={customerSaleId}
                      style={{ width: "100%", minWidth: 200 }}
                      showSearch
                      placeholder={"Please Select Sale"}
                      options={selectCustomerSales}
                      filterOption={filterOption}
                      // onSearch={handleSearchSale}
                      // onChange={handleChange}
                      onChange={(value, option) => {
                        if (value === "ALL") {
                          setCustomerSaleId(undefined);
                        } else {
                          setCustomerSaleId(value);
                        }
                        setCustomerSaleName(option.label); // ✅ เก็บชื่อไว้โชว์ใน UI อื่น ถ้าจำเป็น
                        handleChange(value);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>

        <Row align="middle" justify="center">
          <Col span={24}>
            <Card>
              <Tabs type="card" items={initialItems.filter((item) => item.visible)} />
            </Card>
          </Col>
        </Row>
        {(data.type === "CREATE" && hasPermission(permissions.Customer?.ADD)) ||
        (data.type === "EDIT" && hasPermission(permissions.Customer?.CHANGE)) ||
        hasPermission(permissions.CustomerBillImage.ADD) ||
        hasPermission(permissions.CustomerBillImage.CHANGE) ? (
          <Row align="middle" justify="end" style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              disabled={
                data.type === "CREATE" &&
                (!validateCreateCustomerRequired.fieldCustomerCode || !validateCreateCustomerRequired.fieldCustomerName)
              }
              onClick={onSubmit}
              style={{ marginRight: "10px" }}
            >
              {t("BTN_Save", { ns: "buttons" })}
            </Button>
          </Row>
        ) : undefined}
      </Spin>
    </>
  );
};
